'use client';
import { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';

export default function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className=" mb-2">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center text-left rounded-sm text-gray-700 
        bg-gray-100 px-2 py-4 text-[18px] font-bold cursor-pointer">
        <span>{question}</span>
        <DownOutlined className={`w-5 h-5 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      <div
        className={` text-gray-600 border border-gray-300 rounded-b-xl  text-md transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}>
        <div className="p-3"> {answer}</div>
      </div>
    </div>
  );
}
